import { FC } from 'react'
import styles from './Text.module.scss'
import { TextProps } from './Text.type'
import classNames from 'classnames'

const Text: FC<TextProps> = ({
  type = 'body-2',
  className,
  children,
  color,
  align,
  style,
  ...rest
}) => {
  return (
    <div
      className={classNames(
        styles.text,
        styles[type.replace('-', '_')],
        styles[`text_${color?.replace('-', '_')}`],
        className
      )}
      style={{ textAlign: align, ...style }}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Text
